import { notification } from "antd";
import axios from "axios";
import { ClientToken } from "./Constant";
import { getCookieValue } from "./Storage";

const httpClient = axios.create({
  // baseURL: import.meta.env.VITE_API_URL,
  // baseURL: "https://api-ncdclims.ncdc.gov.ng/api/",
  // baseURL: "http://localhost:8000/api/",
  baseURL: "https://test-api.en-lis.com/api/",
  timeout: 120_000,
});
// 
// pick the token from the cookie and set it in the header
httpClient.interceptors.request.use(
  (config) => {
    const access = getCookieValue(ClientToken) ?? null;

    // Set authorization token
    if (access) {
      config.headers.Authorization = `Bearer ${access}`;
    }
    return config;
  },
  (error) => {
    // Handle request error
    console.error("Request error:", error);
    return Promise.reject(error);
  },
);

// write an interceptor to get error from api response

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 403 Forbidden - auto logout and redirect
    if (error?.response?.status === 403) {
      // Clear authentication token
      document.cookie = `${ClientToken}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

      // Show brief message
      notification.warning({
        message: "Session Expired",
        description: "Your session has expired. Please log in again.",
        duration: 3,
      });

      // Redirect to login after a short delay
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);

      return Promise.reject(error);
    }

    const enLisError = error?.response?.data || error;

    if (error?.response?.data) {
      // Silently skip notification for invalid/expired token errors (e.g., during logout)
      if (enLisError?.error === "Invalid or expired token.") {
        return Promise.reject([enLisError, error]);
      }

      const errorDescriptions = [];

      for (const fieldName in enLisError) {
        const fieldValue = enLisError[fieldName];

        // Check if the value field is an array
        if (Array.isArray(fieldValue)) {
          // Handle array values, e.g., join them into a string
          const arrayValueAsString = fieldValue.join(", ");
          errorDescriptions.push(
            `${fieldName.toUpperCase()}: ${arrayValueAsString}`,
          );
        } else {
          // Handle non-array (string) values
          errorDescriptions.push(`${fieldName.toUpperCase()}: ${fieldValue}`);
        }
      }

      notification.error({
        message: "Error Occurred...",
        description: errorDescriptions?.join("\n"),
        duration: 6,
      });
      return Promise.reject([enLisError, error]);
    } else {
      return Promise.reject(["enLisError", error]);
    }
  },
);

export { httpClient };
